import { DialogComponent } from '@theme/dialog';

/**
 * Shared dialog-backed drawer lifecycle.
 *
 * Standardizes trigger aria state while keeping the native dialog shell used by
 * cart and future drawer-like surfaces.
 *
 * @typedef {object} Refs
 * @property {HTMLDialogElement} dialog
 * @property {HTMLElement | undefined} [trigger]
 *
 * @extends {DialogComponent<Refs>}
 */
export class DrawerDialogComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    this.#syncTriggerState(this.refs.dialog?.open ?? false);
  }

  showDialog() {
    if (this.refs.dialog.open) return;

    this.#syncTriggerState(true);
    super.showDialog();
    this.afterDrawerOpen();
  }

  closeDialog = async () => {
    if (!this.refs.dialog.open) return;

    this.#syncTriggerState(false);
    await this.closeDialogInternal();
    this.afterDrawerClose();
  };

  open() {
    this.showDialog();
  }

  close() {
    return this.closeDialog();
  }

  toggle() {
    return this.refs.dialog.open ? this.close() : this.open();
  }

  afterDrawerOpen() {}

  afterDrawerClose() {}

  #syncTriggerState(isOpen) {
    if (!(this.refs.trigger instanceof HTMLElement)) return;

    this.refs.trigger.setAttribute('aria-expanded', String(isOpen));
  }
}
